import React, { useState, useEffect } from 'react';
import { Grid, Typography, Link, CssBaseline, Paper, Alert } from "@mui/material";
import { CompTextFieldNew } from "../../../components/newComponents/TextField.js";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {login, setLoggedIn, searchFunction, oauth2Success, setLocationName} from "../auth.actions";
import { getMunicipality } from "../../municipality/municipality.actions";
import { closeAlert, getChoices } from "../../root/root.actions";
import {getReminders, getUserSettings} from "../../user/user.actions";
import { accessDeniedResponse } from "../../api/actions";
import { useNavigate } from 'react-router-dom';
import { withRouter } from '../../utils/withRouter.js';
import { ReactComponent as ErrorIcon } from "../../../styles/images/IconError.svg";
import { ReactComponent as WarningIcon } from "../../../styles/images/IconWarning.svg";
import { ReactComponent as InfoIcon } from "../../../styles/images/IconInfo.svg";
import { ReactComponent as SuccessIcon } from "../../../styles/images/IconSuccess.svg";
import i18n from "../../../i18n.js";
import { ButtonPrimary } from '../../../components/newComponents/ButtonPrimary.js';
import AppHeader from '../../../components/newComponents/AppHeader.js';
import {CompCheckbox} from "../../../components/Checkbox";
import {initializeMsal, msalConfig, msalInstance} from "./entraAuthService";

const LoginComponent = (props) => {
    const [state, setState] = useState({
        error: null,
        email: '',
        password: '',
        rememberme: false,
        code: '',
        codeerror: null
    });
    const [isLoading, setIsLoading] = useState(false);

    const logoLang = i18n.language === 'fi' ? 'Logo_nuodo_login_new2025' : 'Logo_ungdo_login_new2025';
    const logoSrc = `${process.env.PUBLIC_URL}/media/images/${logoLang}.svg`;
    const navigate = useNavigate();

    const handleEntraLogin = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            await initializeMsal();
            //Microsoft Popup
            const result = await msalInstance.loginPopup({
                scopes: ["api://"+msalConfig.auth.clientId+"/access_as_user"],
                prompt: "select_account"
            });

            props.oauth2Success(result.accessToken, (data, response) => {

                props.closeAlert();
                props.setLoggedIn(data, response);
                props.getChoices();
                props.getReminders();
                props.getUserSettings();
                props.getMunicipality(data.mainMunicipalityId);
                return setLoggedIn(data, response);
            }, (error) => {
                console.error(error);
                return accessDeniedResponse(error);
            });
        } catch (error) {
            console.log(error);
            return accessDeniedResponse(error);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        document.title = props.t('login.title') + " - " + props.t('common.title');
    }, [props.t]);

    const handleChange = (event) => {
        setState(prevState => ({
            ...prevState,
            [event.target.name]: event.target.value
        }));
    };


    const handleMultiselectChange = (event, value, choice) => {
        event.preventDefault();
        setState(prevState => ({
            ...prevState,
            rememberme: !value
        }));
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setState(prevState => ({ ...prevState, error: '' }));
        props.login(state.email, state.password, state.rememberme, (data, response) => {
            props.closeAlert();
            props.setLoggedIn(data, response);
            props.getChoices();
            props.getReminders();
            props.getUserSettings();
            props.getMunicipality(data.mainMunicipalityId);
            return setLoggedIn(data, response);
        }, (error) => {
            console.error(error);
            return accessDeniedResponse(error);
        });
    };

    const handleSearch = () => {
        if (state.code === '') {
            setState(prevState => ({
                ...prevState,
                codeerror: props.t('feedback.feedback_empty_search')
            }));
            return;
        }
        props.searchFunction(state.code, (data, response) => {
            props.setLocationName(data[0].locationName);
            navigate('/feedback/' + state.code);
            return { type: "ignore", payload: "ignore" };
        }, (data) => {
            setState(prevState => ({
                ...prevState,
                codeerror: props.t('feedback.' + data.response.data.data.error)
            }));
            return { type: "ignore", payload: "ignore" };
        });
    };

    const { t, alert } = props;

    const shareFunctionChoice = [
        {
            label: t('login.remember_me'),
            key: "rememberme",
            value: state.rememberme
        }
    ]

    const alertComponent = alert?.isOpen ? (
        <Alert onClose={props.closeAlert}
               severity={alert.severity}
               iconMapping={{
                   error: <ErrorIcon fontSize="inherit"/>,
                   warning: <WarningIcon fontSize="inherit"/>,
                   info: <InfoIcon fontSize="inherit"/>,
                   success: <SuccessIcon fontSize="inherit"/>
               }}
        >
            {alert.text}
        </Alert>
    ) : (<div />);

    return (
        <Grid className={'loginRoot'} sx={{paddingLeft: "0px !important", paddingRight: "0px !important", display: 'block'}}>
            <AppHeader />
            <CssBaseline/>

            <Grid className='site-wrapper loginBackgroundImage' sx={{width: '100%', paddingLeft: '20vh'}}>
                <Grid className='login-box-wrapper' component={Paper} elevation={6} square size={{ xs: 12, sm: 9, md: 6 }} sx={{ height: '90vh'}}>

                    <div className={'paper'}>
                        <div className={'paperHeader'}>
                            <img className='login-logo'
                                 src={logoSrc} alt={t('common.youth_work')}
                            />
                        </div>
                        <Grid container spacing={6} className={'paperContent'}>
                            <Grid>
                                <Typography component="h1" variant='h4' >
                                    {t('login.title')}
                                </Typography>
                                {alertComponent}
                                <form className='login-form' noValidate autoComplete="off" onSubmit={handleSubmit}>
                                    <CompTextFieldNew
                                        variant="outlined"
                                        required
                                        isLabelShrink={true}
                                        className='email-input login-input'
                                        fullWidth
                                        id="email"
                                        label={t('login.email')}
                                        type="email"
                                        name="email"
                                        autoComplete="email"
                                        autoFocus
                                        onChange={handleChange}
                                        value={state.email}
                                    />
                                    <CompTextFieldNew
                                        variant="outlined"
                                        isLabelShrink={true}
                                        required
                                        className='pw-input login-input'
                                        fullWidth
                                        name="password"
                                        label={t('login.password')}
                                        type="password"
                                        id="password"
                                        onChange={handleChange}
                                        value={state.password}
                                        autoComplete="current-password"
                                    />
                                    <ButtonPrimary type="submit" variant="contained" color="primary" className={'button-login button-primary'} sx={{width: '200px', height: '40px'}}>
                                        {t('login.login_button')}
                                    </ButtonPrimary>
                                    <CompCheckbox
                                        booleanmode={true}
                                        rows={shareFunctionChoice}
                                        selected={state}
                                        onChange={handleMultiselectChange}
                                        name={"feedbackChoices"}
                                    />
                                    <Grid sx={{marginTop: '15px'}}>
                                        <Link href="/forgot_password" variant="body2">
                                            {t('login.forgot_password')}
                                        </Link>
                                    </Grid>
                                    
                                    { !isLoading &&
                                        <Grid sx={{marginTop: '15px'}}>
                                            <ButtonPrimary variant="contained" color="primary" className={'button-login'} onClick={handleEntraLogin}>
                                                {t('login.login_with_entra_id')}
                                            </ButtonPrimary>
                                        </Grid>
                                    }
                                </form>
                            </Grid>
                            <Grid container spacing={2} sx={{padding: '0px !important'}} aria-live='polite'>
                                <Typography component="h2" variant='h5'>{t('feedback.question_header')}</Typography>
                                <Typography component="h3">{t('feedback.question')}</Typography>
                                <Grid size={{ xs: 12, sm: 8 }}>
                                    <CompTextFieldNew
                                        label={t('feedback.function_code')}
                                        value={state.code}
                                        isLabelShrink={true}
                                        name="code"
                                        onChange={handleChange}
                                    />
                                    <ButtonPrimary variant="contained" color="primary" className={'button-login'} onClick={handleSearch}>{t('feedback.search')}</ButtonPrimary>
                                </Grid>
                                {state.codeerror && (
                                    <Grid size={{ xs: 12, sm: 12 }}>
                                        <Typography component="h2">{t(state.codeerror)}</Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <div>
                            {/* <Copyright/> */}
                            {/* <Link href={lang}>
                            <img src={process.env.PUBLIC_URL + t(i18n.language === "sv" ? '/media/images/AVI_logo_sv_SE.svg' : '/media/images/AVI_logo_fi_FI.svg')} alt={t('common.youth_work')} />
                        </Link> */}
                        </div>
                    </div>
                    <Grid container className={'footer-container'}>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 4,
                                md: 3
                            }}>
                            <a href={'https://nuorisotilastot.fi/wp-content/uploads/2025/01/2025_01_07_Tietosuojailmoitus_nuodo.pdf'} target='_blank' rel="noopener noreferrer" className={'link-data-privacy'}>
                                {t('footer.privacy_statement')}
                            </a>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 4,
                                md: 3
                            }}>
                            <a href={'https://nuorisotilastot.fi/2350/uncategorized/nuodo-info/'} target='_blank' rel="noopener noreferrer" className={'link-accessibility'}>
                                {t('footer.accessibility_statement')}
                            </a>

                        </Grid>
                        <Grid /* sx={{width: '33%'}} */
                            size={{
                                xs: 12,
                                sm: 4,
                                md: 3
                            }}>
                            <div className={'copyright'}>© {t('common.application_owner')} {new Date().getFullYear()}</div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

const mapStateToProps = state => ({
    alert: state.root.alert
});

const mapDispatchToProps = dispatch => ({
    searchFunction: (queryString, onSuccess, onFailure) => dispatch(searchFunction(queryString, onSuccess, onFailure)),
    login: (username, password, rememberme, onSuccess, onFailure) => dispatch(login(username, password, rememberme, onSuccess, onFailure)),
    setLoggedIn: (data, response) => dispatch(setLoggedIn(data, response)),
    closeAlert: () => dispatch(closeAlert()),
    getMunicipality: (id) => dispatch(getMunicipality(id)),
    getChoices: () => dispatch(getChoices()),
    getReminders: () => dispatch(getReminders()),
    getUserSettings: () => dispatch(getUserSettings()),
    oauth2Success: (code, onSuccess, onFailure) => dispatch(oauth2Success(code, onSuccess, onFailure)),
    setLocationName: (name) => dispatch(setLocationName(name))
});

export const Login = connect(mapStateToProps, mapDispatchToProps)(withTranslation('translation')(withRouter(LoginComponent)));